import styled from 'styled-components';
import RichTextStyleWrapper from '../../../base/richTextStyleWrapper';
import media from '../../../../constants/media';

export const Wrapper = styled.div``;

export const FormWrapper = styled.div``;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const InfoTextWrapper = styled(RichTextStyleWrapper)`
	max-width: 24rem;

	${media.desktopLarge`
		margin-left: 8rem;
	`};
`;
